
    // <auto-generated />

    import { AsyncResult } from '../async-result';
    import { DataServiceQuery } from '../DataServiceQuery';
    import { PickingList } from '../Entities/CommerceTypes.g';
    import { PickingListClass } from '../Entities/CommerceModels.g';
    import { IContext, IDataServiceRequest, IQueryResultSettings, NullResult } from '../Interfaces';
    import { executeAction } from '../retail-action';

    
    
    function pickingListsQuery(orderId?: string): DataServiceQuery {
        var key = (orderId) ? { OrderId: orderId } : null;
        return new DataServiceQuery("PickingLists", "PickingList", PickingListClass, key);
    }
    
    export function createCreateInput(entity: PickingList): IDataServiceRequest {
        return pickingListsQuery().create(entity);
    }

    export function createPickingListAsync(context: IContext, entity: PickingList): AsyncResult<PickingList> {
        const request = createCreateInput(entity);
        return executeAction<PickingList>(request, context);
    }

    export function createUpdateInput(entity: PickingList): IDataServiceRequest {
        return pickingListsQuery(entity.OrderId).update(entity);
    }

    export function updateAsync(context: IContext, entity: PickingList): AsyncResult<PickingList> {
        const request = createUpdateInput(entity);
        return executeAction<PickingList>(request, context);
    }

    export function createDeleteAsync(entity: PickingList): IDataServiceRequest {
        return pickingListsQuery(entity.OrderId).delete();
    }

    export function deleteAsync(context: IContext, entity: PickingList): AsyncResult<NullResult> {
        const request = createDeleteAsync(entity);
        return executeAction<NullResult>(request, context);
    }

    export function createReadAsync(orderId: string): IDataServiceRequest {
        return pickingListsQuery(orderId).read();
    }

    export function readAsync(context: IContext, orderId: string): AsyncResult<PickingList> {
        const request = createReadAsync(orderId);
        return executeAction<PickingList>(request, context);
    }

    export function createReadAllAsync(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
        return pickingListsQuery().resultSettings(queryResultSettings).read();
    }

    export function readAllAsync(context: IContext): AsyncResult<PickingList[]> {
        const request = createReadAllAsync(context.queryResultSettings);
        return executeAction<PickingList[]>(request, context);
    }
    
    export function createCommitInput(orderId: string, ): IDataServiceRequest {      
        const query = pickingListsQuery(orderId);
        return query.createDataServiceRequestForOperation('Commit', true, '', '', {bypassCache: 'get', returnEntity: ''}, { });
    }    
    
    export function commitAsync(context: IContext, orderId: string):AsyncResult<NullResult> {
        const request = createCommitInput(orderId);
        return executeAction<NullResult>(request, context);
    }          
          
    